import React, { PureComponent } from 'react';

import _ from 'underscore'


export default class GaugeChart extends PureComponent {

    generateGraph(){
        

        am4core.addLicense("CH204843208");
        am4core.options.queue = true;

        am4core.options.onlyShowOnViewport = true;
 
        var chart = am4core.create("gaugeChart", am4charts.GaugeChart);
        chart.innerRadius = -15;

        var axis = chart.xAxes.push(new am4charts.ValueAxis());
        axis.min = 0;
        axis.max = 100;
        axis.strictMinMax = true;


        var gradient = new am4core.LinearGradient();


        gradient.stops.push({ color: am4core.color("red") })

        gradient.stops.push({ color: am4core.color("orange") })


        gradient.stops.push({ color: am4core.color("yellow") })
        gradient.stops.push({ color: am4core.color("green") })

        axis.renderer.line.stroke = gradient;
        axis.renderer.line.strokeWidth = 15;
        axis.renderer.line.strokeOpacity = 1;
        axis.renderer.grid.template.disabled = true;

        var hand = chart.hands.push(new am4charts.ClockHand());
        hand.axis = axis;
        hand.value = this.props.percent;

    }

    
    shouldComponentUpdate(nextProps, nextState) {
       return nextProps.percent != this.props.percent
    }



    componentDidUpdate() {
        this.generateGraph();
    }


    componentDidMount() {
        this.generateGraph();
    }



    render() {
        return (
            <div>
                <div id="gaugeChart" style={{ width: "274px", height: '165px' }} />
            </div>
        );
    }
}
